import { IsNumber, IsOptional, IsString, IsUUID, Min } from 'class-validator';

export class InitPaymentDto {
  @IsNumber()
  @Min(1)
  monto: number;

  @IsOptional()
  @IsString()
  moneda?: string = 'PYG';

  @IsString()
  descripcion: string;

  @IsString()
  origenModulo: string;

  @IsOptional()
  @IsUUID()
  origenId?: string;

  @IsOptional()
  @IsUUID()
  clienteId?: string;
}
